<template>
  <div class="product-configs-container">
    <div v-if="headline" class="product-configs-headline">
      {{ headline }} -
      <span class="product-configs-value">
        {{ selectedLabel }}
      </span>
    </div>

    <div class="product-configs">
      <BaseProductSeriesConfigurationItem
        v-for="(item, index) in items"
        :key="index"
        :item="item"
        :selected="item[keySelected] === selected"
        :disabled="
          (isFromQRCode && item[keySelected] !== selected) ||
            item.disabled
        "
        @click="
          isFromQRCode || item[keySelected] == selected
            ? null
            : $emit('change', item)
        "
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseProductSeriesConfigurations',

  props: {
    headline: {
      type: String,
      default: '',
    },
    keyTitle: {
      type: String,
      required: true,
    },
    keySelected: {
      type: String,
      required: true,
    },
    keyImage: {
      type: String,
      default: 'main_image',
    },
    keyPrice: {
      type: String,
      default: 'min_price',
    },
    items: {
      type: Array,
      default: () => [],
    },
    selected: {
      type: Object,
      default: () => ({}),
    },
    isFromQRCode: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    BaseProductSeriesConfigurationItem: () =>
      import(
        '@/components/base/product/BaseProductSeriesConfigurationItem'
      ),
  },

  computed: {
    selectedLabel() {
      return (
        this.items?.find(
          item => item[this.keySelected] === this.selected,
        )?.name ?? ''
      )
    },
  },
}
</script>

<style lang="stylus" scoped>
.product-configs-container
	display flex
	flex-direction column
	gap: 16px

// BaNANA Styles
.-is-bnn {
	.product-configs {
		display: grid
		grid-template-columns: repeat(1, 1fr)
		gap: 16px

		@media screen and (min-width: 520px) {
			grid-template-columns: repeat(2, 1fr)
		}

		@media screen and (min-width: 768px) {
			grid-template-columns: repeat(1, 1fr)
		}

		@media screen and (min-width: 1024px) {
			grid-template-columns: repeat(2, 1fr)
		}
	}

	.product-configs-headline {
		font-size: 14px
		color: rgba(0, 0, 0, 0.45);
	}

	.product-configs-value {
		font-weight: 600;
		color: rgba(0, 0, 0, 0.85);
	}
}

// Studio7 Styles
.product-configs{
	display: grid;
	gap: 16px;
	grid-template-columns: repeat(1, 1fr);

	@media screen and (max-width: 768px) {
		grid-template-columns: repeat(1, 1fr);
	}
}
</style>
